module.exports = __webpack_public_path__ + "img/vendor_logo5.5504a4b1.png";